import { render, staticRenderFns } from "./create-promotion.vue?vue&type=template&id=8c9f075e&scoped=true"
import script from "./create-promotion.vue?vue&type=script&lang=js"
export * from "./create-promotion.vue?vue&type=script&lang=js"
import style0 from "./create-promotion.vue?vue&type=style&index=0&id=8c9f075e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9f075e",
  null
  
)

export default component.exports